import { register } from '../component.js';
import 'react';

var _socialIcons_twitch = register("twitch", {"color":"#6441A5","path":"M0,0v64h64V0H0z M47,35.8l-7.6,7.6h-5.7l-3.8,3.8H26v-3.8h-7V23.1l1.9-5.1H47V35.8z M29.2,42.8L33,39h7l4.5-4.5 v-14h-21V39h5.7V42.8z M37.5,25.6H40v7.6h-2.5V25.6z M30.5,25.6H33v7.6h-2.5V25.6z"});

export { _socialIcons_twitch as default };
